// @flow

import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { ClipLoader } from 'react-spinners';
import { FormattedMessage } from "react-intl";
import queryString from "query-string";
import { getClassName } from "ui-kit/utils/component";
import { login, setLocale } from "ducks/user/actions";
import { Header } from "./header/Header";
import "./Login.scss";
import "./css/font-awesome.min.css"
import { upholdAuth } from "config/http";

const ccn = getClassName("LoginPage");

class Login extends Component {
  state = {
    close: "open",
    loading: false
  }
  componentDidMount() {
    if (window.location.search) {
      const { user } = this.props;
      const parsed = queryString.parse(window.location.search);
      this.props.login(parsed.code, user.lang.toLowerCase());
    }
  }
  componentWillReceiveProps(next) {
    if(this.props.user && next.user && this.props.user.logging !== next.user.logging) {
      this.setState({loading: next.user.logging})
    }
  }
  selectLang = (lang) => {
    this.props.setLocale(lang)
  }
  buttonEvent = (loginSignup) => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const url = window.location.origin;
    const intention = loginSignup==='signup'?'&intention=signup':'&intention=login'
    const { user } = this.props;

    if((/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)) {
      setTimeout(() => window.location = `${upholdAuth}${intention}&lang=${user.lang==="ES"?"es_ES":user.lang==="PT"?"pt_PT":"en_US"}&state=lc+${url}/login/`, 1);
    } else if(/android/i.test(userAgent)) {
      setTimeout(() => window.location = `${upholdAuth}${intention}&lang=${user.lang==="ES"?"es_ES":user.lang==="PT"?"pt_PT":"en_US"}&state=lc+${url}/login/`, 1);
    } else {
      window.location = `${upholdAuth}${intention}&lang=${user.lang==="ES"?"es_ES":user.lang==="PT"?"pt_PT":"en_US"}&state=lc+${url}/login/`;
    }
  }

  closeLangList = () => {
    this.setState({close: "close"})
  }
  componentDidUpdate(prevProps) {
    if(this.state.close==="close") {
      this.setState({close: "open"})
    }
  }

  openGooglePlayOrApp = () => {
    document.location.replace('hedged-bitcoin://app')
    setTimeout(() => window.location = "https://play.google.com/store/apps/details?id=com.hedged_bitcoin", 1000)
  }

  render() {
    const { user } = this.props;
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return (
      <Fragment>
        <div className={ccn()} onClick={this.closeLangList}>
          <Header headerUserLang={user.lang.toLowerCase()} btnEvent={() => this.buttonEvent('login')} toClose={this.state.close} />
          <main className={ccn(`main${user.lang==="PT"?" portugal":""}`)}>
            <h1>
              <FormattedMessage id="hbc.login.title" defaultMessage="Hedged Bitcoin" />
            </h1>
            <h5>
              <FormattedMessage id="hbc.login.powered" defaultMessage="Powered by the Uphold Platform" />
            </h5>
            <div>
              <div className={`Button--sign-up-with-img ${user.lang==="ES"?"spanish":""} ${(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)?"Button--sign-up-with-iphone":""}`} onClick={() => this.buttonEvent('signup')}>
                <FormattedMessage id="hbc.login.button1" defaultMessage="Connect with" />
                <FormattedMessage id="hbc.login.button2" defaultMessage="Uphold" />
              </div>
            </div>
            {
              /android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) ?
                <ul className="list-inline social-buttons">
                  {
                    /android/i.test(userAgent) ?
                      <li><div onClick={this.openGooglePlayOrApp}><i className="fa fa-play"></i></div></li>
                    :
                      null
                  }
                </ul>
              :
                <div style={{height: '20px'}}></div>
            }
            <br />
            <h5>
              <FormattedMessage id="hbc.login.terms0" defaultMessage="By authorizing the Hedged Bitcoin service" />{","}<br />{" "}
              <FormattedMessage id="hbc.login.terms1" defaultMessage="you have read and agree to our" />{" "}
              <a href="https://support.hedgedbitcoin.com/hc/en-us/articles/360018818751" target="_blank" rel="noopener noreferrer">
                <FormattedMessage id="hbc.login.terms2" defaultMessage="terms of service" />
              </a>{" "}
              <FormattedMessage id="hbc.login.terms3" defaultMessage="and" />
              {" "}
              <a href={`https://support.hedgedbitcoin.com/hc/en-us/articles/360018818751${(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)?"/":""}#privacy`} target="_blank" rel="noopener noreferrer">
                <FormattedMessage id="hbc.login.terms4" defaultMessage="privacy policy" />
              </a>
            </h5>
            <ul className="list-inline social-buttons langs-top-icon">
              <li><i className="fa fa-language" aria-hidden="true"></i></li>
            </ul>
            {<h5>
              <ul className={ccn("sublist")}>

                {
                  user.lang !== "EN" ?
                    <li className={ccn("subitem")}>
                      <div className={ccn("sublink")} onClick={() => this.selectLang("EN")}>English</div>
                    </li>
                  :
                   null
                }
                {
                  user.lang !== "ES" ?
                    <li className={ccn("subitem")}>
                      <div className={ccn("sublink")} onClick={() => this.selectLang("ES")}>Español</div>
                    </li>
                  :
                   null
                }
                {
                  user.lang !== "PT" ?
                    <li className={ccn(`subitem${user.lang!=="PT"?" portugal":""}${user.lang!=="ZH"?" plusChinese":""}`)}>
                      <div className={ccn("sublink")} onClick={() => this.selectLang("PT")}>Português</div>
                    </li>
                  :
                   null
                }
                {
                  user.lang !== "ZH" ?
                    <li className={ccn(`subitem${user.lang!=="ZH"?" chinese":""}`)}>
                      <div className={ccn("sublink")} onClick={() => this.selectLang("ZH")}>中文</div>
                    </li>
                  :
                   null
                }
              </ul>
            </h5>}
          </main>
          <div style={{position: "absolute", justifyContent: "center", width: "100%", display: (this.state.loading?"flex":"none"), height: "100%", alignItems: "center"}}>
            <ClipLoader sizeUnit={"px"} size={150} color={'#fed136'} loading={this.state.loading} />
          </div>
        </div>
        <footer>
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <span className="copyright">&copy; 2018-{new Date().getFullYear()} Ternary Intelligence Inc.</span>
              </div>
              <div className="col-md-4">
                <ul className="list-inline social-buttons">
                    <li>
                      <a href="https://www.linkedin.com/company/hedgedbitcoin" title="Hedged Bitcoin on LinkedIn">
                        <i className="fa fa-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://twitter.com/HedgedBitcoin" title="Hedged Bitcoin on Twitter">
                        <i className="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.facebook.com/HedgedBitcoin-248355095819514/" title="Hedged Bitcoin on Facebook">
                        <i className="fa fa-facebook"></i>
                      </a>
                    </li>
                </ul>
              </div>
              <div className="col-md-4">
                <ul className={`list-inline quicklinks${["EN", "ZH"].includes(user.lang)?" english-lang":""}`}>
                    <li>
                      <a href="https://www.hedgedbitcoin.com/smoothing-the-bitcoin-ride.pdf" target="_blank" rel="noopener noreferrer">
                        <FormattedMessage id="hbc.login.white.paper" defaultMessage="White Paper" />
                      </a>
                    </li>
                    <li>
                      <a href="https://support.hedgedbitcoin.com/hc/en-us/articles/360018818751" target="_blank" rel="noopener noreferrer">
                        <FormattedMessage id="hbc.login.privacy.policy" defaultMessage="Terms of Service and Privacy Policy" />
                      </a>
                    </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  router: state.router
})

export default connect(mapStateToProps, {login, setLocale})(Login);




// WEBPACK FOOTER //
// ./src/containers/auth/login/Login.js